<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      :searchDesc="searchDesc"
      @searchSubmit="searchSubmit"
      @refresh-change="getlist"
      @refreshBtn="refreshBtn"
    ></zx-table>
    <div class="from">
      <ele-form-dialog
        v-model="formData"
        :formDesc="formDesc"
        :request-fn="handleSubmit"
        :rules="rules"
        labelPosition="left"
        :form-attrs="{ size: 'small' }"
        :dialogAttrs="{
          center: false,
          'destroy-on-close': true,
          'custom-class': 'formD'
        }"
        :visible.sync="dialogVisible"
        @request-success="handleSuccess"
        :title="'审核退单'"
      ></ele-form-dialog>
    </div>
    <!-- <el-dialog title="发起退款" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <span>退款备注</span>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入退款备注"
        v-model="refundPostData.refuse_reason"
      ></el-input>
      <el-radio v-model="refundPostData.status" :label="1">同意</el-radio>
      <el-radio v-model="refundPostData.status" :label="2">驳回</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="refundSubmit">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import * as order from "@/api/product/order.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      formData: {},
      formDesc: {
        trade_no: {
          type: "text",
          label: "订单号"
        },
        refund_no: {
          type: "text",
          label: "退单号"
        },
        link_name: {
          type: "text",
          label: "下单人"
        },
        link_mobile: {
          type: "text",
          label: "下单人电话"
        },
        // link_idcard: {
        //   type: "text",
        //   label: "下单人身份证号"
        // },
        body: {
          type: "text",
          label: "产品名称"
        },
        quantity: {
          type: "text",
          label: "数量"
        },
        ip: {
          type: "text",
          label: "发起支付IP"
        },
        remark: {
          type: "text",
          label: "退款发起备注"
        },
        type: {
          label: "审核",
          type: "radio",
          required: true,
          default: 1,
          options: [
            {
              text: "通过退单",
              value: 1
            },
            {
              text: "驳回退单",
              value: 2
            }
          ]
        },
        refuse_reason: {
          type: "input",
          label: "退款审核备注"
        }
      },
      rules: {},
      dialogVisible: false,
      refundPostData: {
        refund_id: "",
        status: 1,
        refuse_reason: ""
      },

      searchDesc: {
        link_name: {
          type: "input",
          label: "下单人"
        },
        link_mobile: {
          type: "input",
          label: "电话"
        },
        trade_no: {
          label: "订单号",
          type: "input"
        },
        date: {
          field: "date",
          label: "时间范围",
          type: "daterange",
          attrs: {
            valueFormat: "yyyy-MM-dd",
            pickerOptions: {
              shortcuts: [
                {
                  text: "最近一周",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近一个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit("pick", [start, end]);
                  }
                },
                {
                  text: "最近三个月",
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit("pick", [start, end]);
                  }
                }
              ]
            }
          }
        }
      },
      searchData: {},
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 25,
        pageSizes: [15, 25, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "计划",
        // 多选 默认:false;
        selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: true,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: false,
        // 折叠筐 默认:false;
        expand: false,
        expandStyle: "width:50%;display:inline-flex;",
        column: [
          {
            prop: "trade_no",
            // 列名
            label: "订单号",
            hide: true
          },
          {
            prop: "link_name",
            // 列名
            label: "下单人",
            hide: true
          },
          {
            prop: "link_mobile",
            // 列名
            label: "下单人电话",
            hide: true
          },
          {
            prop: "link_idcard",
            // 列名
            label: "下单人身份证号",
            hide: false
          },
          {
            prop: "body",
            // 列名
            label: "产品名称",
            hide: true
          },
          {
            prop: "quantity",
            // 列名
            label: "数量",
            width: 100,
            hide: true
          },
          {
            prop: "create_time",
            // 列名
            label: "订单创建时间",
            hide: false
          },

          {
            prop: "ip",
            // 列名
            label: "发起支付IP",
            hide: false
          }
        ],
        btnList: [
          {
            name: "退单审核",
            size: "mini",
            type: "text",
            click: (id, row, index) => {
              this.dialogVisible = true;
              this.formData = { ...row, ...row.refund_info };
            }
          }
        ]
      },
      tableData: []
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    //   退款提交
    handleSubmit(data) {
      order.editOrderRefund
        .r({
          refund_id: data.refund_id,
          type: data.type,
          refuse_reason: data.refuse_reason ? data.refuse_reason : ""
        })
        .then(res => {
          this.dialogVisible = false;
          this.getlist();
        });
    },
    handleSuccess() {},
    // 刷新
    refreshBtn(e) {
      this.getlist();
    },
    // 搜索提交
    searchSubmit(e) {
      this.searchData = e;
      if (e.date) {
        let date = {
          start_time: e.date[0],
          end_time: e.date[1]
        };
        delete e.date;
        this.searchData = {
          ...e,
          ...date
        };
      }
      if (e) {
        this.page.currentPage = 1;
      }
      this.getlist();
    },
    getlist(e) {
      let that = this;
      let param;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      param["status"] = 0;
      order.getOrderRefundList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    }
  }
};
</script>
<style lang="scss" scoped></style>
